<div aria-labelledby="swal2-title" aria-describedby="swal2-content"
  class="swal2-popup swal2-modal swal2-icon-warning swal2-show" tabindex="-1" role="dialog" aria-live="assertive"
  aria-modal="true" style="display: flex; width: 100%;">
  <div *ngIf="step == 1">
    <div class="swal2-header">
      <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
        <div class="swal2-icon-content">!</div>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@instantBillingQuestionHeader">Wie möchten Sie mit den ausstehenden Ladevorgänge verfahren?</h2>
    </div>
    <div class="card-body">
      <table class="table">
        <thead>
          <tr>
            <th i18n="@@Name">Name</th>
            <th i18n="@@Date">Datum</th>
            <th i18n="@@ChargingAmountInKWh">Lademenge in kWh</th>
            <th i18n="@@Price">Betrag</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let invoiceItem of invoiceItems">
            <td>{{ invoiceItem.recipientUserFullName }}</td>
            <td>{{ parseDate(invoiceItem.createdAt) }}</td>
            <td>{{ invoiceItem.quantity | kwh }}</td>
            <td>€ {{ invoiceItem.total | number: '1.2-2':'de-DE'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div *ngIf="step == 2">
    <div class="swal2-header">
      <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex;">
        <div class="swal2-icon-content">!</div>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: block;" i18n="@@authenticationQuestionHeader">Sollen die
        Autorisierungen von folgenden Benutzer(n) bestehen bleiben?</h2>
    </div>
    <div class="swal2-content">
      <div id="swal2-content" class="swal2-html-container" style="display: block;">{{ recipientNamesDisplay }}</div>
    </div>
  </div>
  <div class="swal2-actions">
    <div class="swal2-loader"></div>
    <button *ngIf="step == 1" type="button" id="instant_billing" class="btn btn-danger me-2" (click)="instantBilling()" aria-label=""
      i18n="@@instantBillingButton">Sofort abrechnen</button>
    <button *ngIf="step == 1" type="button" id="later_billing" class="btn btn-danger me-2" (click)="laterBilling()" aria-label=""
      i18n="@@laterBillingButton">Später abrechnen</button>
    <button *ngIf="step == 1" type="button" id="no_more_billing" class="btn btn-danger me-2" (click)="noMoreBilling()" aria-label=""
      i18n="@@noMoreBillingButton">Nicht mehr abrechnen</button>
    <button *ngIf="step == 2" type="button" id="remove_auth" class="btn btn-danger me-2" (click)="removeAuth()" aria-label=""
      i18n="@@removeAuthButton">Entfernen</button>
    <button *ngIf="step == 2" type="button" id="keep_auth" class="btn btn-danger me-2" (click)="keepAuth()" aria-label=""
      i18n="@@keepAuthButton">Beibehalten</button>
    <button type="button" id="cancel" class="btn btn-yellow" (click)="close()" ngbAutofocus aria-label=""
      i18n="@@CancelButton">Abbrechen</button>
  </div>
</div>
